import { alpha, Box, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useStoreState } from '../../../store/hooks'
import { BOARD_OVERLAY } from '../timing'

export const BoardOverlay = () => {
    const [showOverlay, setShowOverlay] = useState(true)

    const currentPuzzleNumber = useStoreState((state) => state.puzzleQuestView.currentPuzzleNumber)

    useEffect(() => {
        setShowOverlay(true)
        setTimeout(() => {
            setShowOverlay(false)
        }, BOARD_OVERLAY.totalDuration)
    }, [currentPuzzleNumber])

    if (!showOverlay) return null

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                '.topOverlay': {
                    transformOrigin: 'top',
                    position: 'absolute',
                    top: '4px',
                    left: '3px',
                    width: 'calc(100% - 6px)',
                    height: 'calc(50% - 4px)',
                    backgroundColor: (theme) => alpha(theme.palette.background.default, 0.5),
                    animation: `growAnimation ${BOARD_OVERLAY.growAnimation}ms ease forwards`,
                },
                '.bottomOverlay': {
                    transformOrigin: 'bottom',
                    position: 'absolute',
                    bottom: '4px',
                    left: '3px',
                    width: 'calc(100% - 6px)',
                    height: 'calc(50% - 4px)',
                    backgroundColor: (theme) => alpha(theme.palette.background.default, 0.5),
                    animation: `growAnimation ${BOARD_OVERLAY.growAnimation}ms ease forwards`,
                },
                '.text': {
                    textShadow: '1px 1px 2px #000',
                    position: 'absolute',
                    zIndex: 1,
                    opacity: '0',
                    width: '100%',
                    left: 0,
                    right: 0,
                    textAlign: 'center',
                    transform: 'scale(0.6)',
                    animation: `fadeInOutText ${BOARD_OVERLAY.textFadeInOut}ms ease forwards`,
                },
                '@keyframes growAnimation': {
                    '0%': {
                        transform: 'scaleY(0)',
                    },
                    '50%': {
                        transform: 'scaleY(1)',
                    },
                    '100%': {
                        transform: 'scaleY(0)',
                    },
                },

                '@keyframes fadeInOutText': {
                    '0%': {
                        opacity: 0,
                        transform: 'scale(0.6)',
                    },
                    '40%': {
                        opacity: 1,
                        transform: 'scale(1)',
                    },
                    '60%': {
                        opacity: 1,
                        transform: 'scale(1)',
                    },
                    '100%': {
                        opacity: 0,
                        transform: 'scale(0.6)',
                    },
                },
            }}
        >
            <div className="topOverlay"></div>
            <Typography className="text" variant="h2">
                Puzzle {currentPuzzleNumber}/10
            </Typography>
            <div className="bottomOverlay"></div>
        </Box>
    )
}
